// LUMINA · pages/PrivacyPage.jsx
// Static privacy policy page for BTF CANADA / 如意宝金刚社群

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { GD, GDL, BG, TXT, TXT2 } from './vajra/constants';

const FONT = "'Noto Serif SC','Noto Serif',serif";

function SectionHeading({ zh, en }) {
  return (
    <div style={{ marginTop: 40, marginBottom: 14 }}>
      <h2 style={{ margin: 0, fontSize: 18, fontWeight: 700, color: GDL, fontFamily: FONT, letterSpacing: 1 }}>
        {zh}
      </h2>
      <div style={{ fontSize: 12, color: TXT2, marginTop: 3, fontFamily: FONT, fontStyle: 'italic' }}>
        {en}
      </div>
    </div>
  );
}

function Para({ zh, en }) {
  return (
    <div style={{ marginBottom: 16 }}>
      <p style={{ margin: 0, fontSize: 15, lineHeight: 1.85, color: TXT, fontFamily: FONT }}>
        {zh}
      </p>
      <p style={{ margin: '6px 0 0', fontSize: 13, lineHeight: 1.75, color: TXT2, fontFamily: FONT, fontStyle: 'italic' }}>
        {en}
      </p>
    </div>
  );
}

export default function PrivacyPage() {
  const navigate = useNavigate();

  return (
    <div style={{ minHeight: '100vh', background: BG, fontFamily: FONT, color: TXT }}>

      {/* ── Sticky Nav ── */}
      <div style={{
        position: 'sticky', top: 0, zIndex: 100,
        background: 'rgba(253,251,247,0.92)', backdropFilter: 'blur(16px)',
        borderBottom: '1px solid rgba(212,175,55,0.25)',
        padding: '0 32px', height: 56,
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      }}>
        <button
          onClick={() => navigate('/vajra')}
          style={{ display: 'flex', alignItems: 'center', gap: 10, background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}
        >
          <span style={{ color: GD, fontSize: 18 }}>☸</span>
          <div>
            <div style={{ color: GD, fontSize: 14, letterSpacing: 3, fontFamily: FONT }}>如意宝金刚社群</div>
            <div style={{ color: TXT2, fontSize: 9, letterSpacing: 2, opacity: 0.8, fontFamily: FONT }}>BTF CANADA</div>
          </div>
        </button>
        <button
          onClick={() => navigate(-1)}
          style={{
            background: 'none', border: `1.5px solid rgba(107,79,16,0.35)`,
            borderRadius: 8, color: GD, fontSize: 12,
            padding: '6px 18px', cursor: 'pointer', letterSpacing: 1, fontFamily: FONT,
          }}
        >
          返回 / Back
        </button>
      </div>

      {/* ── Content ── */}
      <div style={{ maxWidth: 800, margin: '0 auto', padding: '48px 24px 80px' }}>

        {/* Title */}
        <div style={{ borderBottom: `2px solid rgba(139,105,20,0.25)`, paddingBottom: 24, marginBottom: 8 }}>
          <h1 style={{ margin: 0, fontSize: 28, fontWeight: 700, color: GD, fontFamily: FONT, letterSpacing: 2 }}>
            隐私政策
          </h1>
          <div style={{ fontSize: 16, color: TXT2, marginTop: 4, fontFamily: FONT, fontStyle: 'italic' }}>
            Privacy Policy
          </div>
          <div style={{ marginTop: 14, fontSize: 13, color: TXT2, fontFamily: FONT }}>
            生效日期 / Effective date：2026年1月1日 / January 1, 2026
          </div>
          <div style={{ marginTop: 6, fontSize: 13, color: TXT2, fontFamily: FONT }}>
            发布机构：BTF CANADA（Buddhist Terma Foundation Canada · 加拿大显密文教基金会）
          </div>
        </div>

        {/* Intro */}
        <Para
          zh="本隐私政策说明如意宝金刚社群（BTF CANADA）在您使用本平台时如何收集、使用和保护您的个人信息。请在使用本服务前仔细阅读本政策。"
          en="This Privacy Policy describes how BTF CANADA collects, uses, and protects your personal information when you use this platform. Please read this policy carefully before using our services."
        />

        {/* Section 1 */}
        <SectionHeading zh="1. 收集的信息" en="1. Information We Collect" />
        <Para
          zh="我们在您注册或参与法会时收集您提供的信息，包括姓名、电子邮件地址、法名及相关联系方式。我们还会自动收集设备及使用数据（如IP地址、浏览器类型）以维护平台安全和统计分析。我们不会在未经您同意的情况下收集特别敏感的个人信息。"
          en="We collect information you provide when registering or participating in events, including name, email address, dharma name, and contact details. We also automatically collect device and usage data (such as IP address and browser type) for platform security and analytics. We do not collect specially sensitive personal information without your explicit consent."
        />

        {/* Section 2 */}
        <SectionHeading zh="2. 信息使用" en="2. How We Use Information" />
        <Para
          zh="我们使用您的信息为您提供社群服务、发送法会通知及修行相关资讯、处理您的报名及供养记录，以及改善平台功能。我们不会将您的信息用于商业广告或出售给任何第三方。"
          en="We use your information to provide community services, send event notifications and practice-related communications, process your registrations and offering records, and improve platform features. We do not use your information for commercial advertising or sell it to third parties."
        />

        {/* Section 3 */}
        <SectionHeading zh="3. 信息共享" en="3. Information Sharing" />
        <Para
          zh="除以下情形外，我们不向任何第三方披露您的个人信息：（a）经您明确授权；（b）配合法律要求或执法机构的合法指令；（c）向协助我们运营平台的受信任服务提供商提供（受保密协议约束）。我们的服务提供商不得将您的信息用于其他目的。"
          en="We do not disclose your personal information to third parties except: (a) with your explicit consent; (b) as required by law or valid legal process; (c) to trusted service providers who assist in operating our platform (bound by confidentiality agreements). Service providers may not use your information for other purposes."
        />

        {/* Section 4 */}
        <SectionHeading zh="4. 数据安全" en="4. Data Security" />
        <Para
          zh="我们采取行业标准的安全措施保护您的个人数据，包括传输加密（HTTPS/TLS）、密码哈希存储以及对敏感端点的访问控制。尽管如此，互联网传输无法保证绝对安全，请妥善保管您的账户凭证。"
          en="We implement industry-standard security measures to protect your personal data, including encryption in transit (HTTPS/TLS), hashed password storage, and access controls on sensitive endpoints. However, no internet transmission can be guaranteed absolutely secure — please safeguard your account credentials."
        />

        {/* Section 5 */}
        <SectionHeading zh="5. 您的权利" en="5. Your Rights" />
        <Para
          zh="您有权随时查阅、更正或删除您在本平台上的个人信息。如需行使上述权利，请通过下方联系方式与我们联系，我们将在合理期限内予以回应。您亦可随时注销账户，账户注销后我们将在法律规定的期限内删除您的个人数据。"
          en="You have the right to access, correct, or delete your personal information on this platform at any time. To exercise these rights, contact us using the details below and we will respond within a reasonable timeframe. You may also close your account at any time; upon closure we will delete your personal data within legally required retention periods."
        />

        {/* Section 6 */}
        <SectionHeading zh="6. 联系我们" en="6. Contact Us" />
        <Para
          zh="如您对本隐私政策有任何疑问或需要行使您的权利，请通过以下方式联系我们。"
          en="If you have any questions about this Privacy Policy or wish to exercise your rights, please contact us using the details below."
        />
        <div style={{
          marginTop: 16, padding: '20px 24px',
          background: 'rgba(139,105,20,0.06)', borderRadius: 12,
          border: '1.5px solid rgba(139,105,20,0.2)',
        }}>
          <div style={{ fontSize: 14, color: TXT, fontFamily: FONT, lineHeight: 2 }}>
            <div><strong>BTF CANADA</strong></div>
            <div>Buddhist Terma Foundation Canada · 加拿大显密文教基金会</div>
            <div>
              <span style={{ color: TXT2 }}>电子邮件 / Email：</span>
              <a href="mailto:canada.btf@gmail.com" style={{ color: GDL, textDecoration: 'none' }}>
                canada.btf@gmail.com
              </a>
            </div>
          </div>
        </div>

        {/* Footer note */}
        <p style={{ marginTop: 48, fontSize: 12, color: TXT2, fontFamily: FONT, textAlign: 'center', opacity: 0.75 }}>
          本政策如有修改，将在本页面发布更新版本，并注明生效日期。<br />
          <span style={{ fontStyle: 'italic' }}>Any updates to this policy will be posted on this page with a revised effective date.</span>
        </p>

      </div>
    </div>
  );
}
